module.exports = "<div class=\"wrapper\">\n    <div class=\"sidebar\" data-background-color=\"white\" data-active-color=\"danger\">\n        <sidebar-cmp></sidebar-cmp>\n    </div>\n    <div class=\"main-panel\">\n        <navbar-cmp></navbar-cmp>\n        <div class=\"content\">\n            <router-outlet></router-outlet>\n        </div>\n        <footer-cmp></footer-cmp>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main